import { downloadFileFromBase64 } from "@/utils/downloadFileFromBase64";
import { PaperclipIcon } from "lucide-react";

export function ItemArquivo({ originalname, size, hora, base64String }) {
  return (
    <li className="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
      <div className="flex w-0 flex-1 items-center">
        <PaperclipIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
        <div className="ml-4 flex min-w-0 flex-1 gap-2">
          <span className="truncate font-medium">{originalname}</span>
          <span className="shrink-0 text-gray-400">{size} - {hora}</span>
        </div>
      </div>
      <div className="ml-4 shrink-0">
        <div onClick={() => downloadFileFromBase64(base64String, originalname)} className="font-medium text-red-600 hover:text-red-500 cursor-pointer">
          Download
        </div>
      </div>
    </li>
  )
}